// Runtime config for the Vite SPA. Values come from compile-time env
// (VITE_API_URL / VITE_STORAGE_URL) or build args; falls back to local dev.
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8090';
export const STORAGE_URL = import.meta.env.VITE_STORAGE_URL || 'https://static.zawajme.com/';

// Firebase Authentication is only used for the phone (SMS) verification at
// signup, like the legacy step2. The API key is a public web key; the API
// verifies the resulting ID token server-side with the project id.
export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
  // Local/E2E only: disables reCAPTCHA for the fictional test numbers declared
  // in the Firebase console. Never set in production.
  appVerificationDisabledForTesting:
    import.meta.env.VITE_FIREBASE_APP_VERIFICATION_DISABLED === 'true',
};

// Fictional test number (E.164) validated by the API with a fixed code and no
// SMS, like the legacy "0699999999" protocol. Empty = disabled. The API must be
// configured with the same number (PHONE_TEST_NUMBER / PHONE_TEST_CODE).
export const PHONE_TEST_NUMBER = import.meta.env.VITE_PHONE_TEST_NUMBER || '';
